import {
  convocatoria001,
  n1,
  n2,
  n3,
  n4,
  n5,
  convocatoria002,
  n6,
  n7,
  convocatoria003,
  n8,
  n9,
  n10,
  convocatoria004,
  n11,
  n12,
  n13,
  n14,
  n15,
  convocatoria005,
  n16,
  n17,
  convocatoria006,
  n18,
  n19,
  n20,
  n21,
  convocatoriaObra01,
  lop1,
  lop2,
  lop3,
  convocatoria007,
  n22,
  n23,
  n24,
  n25,
  n26,
  n27,
  n28,
  convocatoriaObra02,
  lop4,
  convocatoria008,
  n29,
  n30,
  n31,
  n32,
  convocatoriaObra03,
  lop5,
  lop6,
  convocatoriaObra04,
  lop7,
  lop8,
  lop9,
  convocatoria009,
  n33,
  n34,
  convocatoria010,
  n35,
  n36,
  n37,
  n38,
  n39,
  convocatoriaObra05,
  lop10,
  lop11,
} from "../../json/anioLicitaciones/2026/anioLicitacion2026";

export const obtenerDatosSeleccionados = (selectedItemIndex) => {
  let datosSeleccionados = [];

  switch (selectedItemIndex) {
    case "CONVOCATORIA 01-2026":
      datosSeleccionados = convocatoria001;
      break;
    case "EA-913005999-N1-2026":
      datosSeleccionados = n1;
      break;
    case "EA-913005999-N2-2026":
      datosSeleccionados = n2;
      break;
    case "EA-913005999-N3-2026":
      datosSeleccionados = n3;
      break;
    case "EA-913005999-N4-2026":
      datosSeleccionados = n4;
      break;
    case "EA-913005999-N5-2026":
      datosSeleccionados = n5;
      break;
    case "CONVOCATORIA 02-2026":
      datosSeleccionados = convocatoria002;
      break;
    case "EA-913005999-N6-2026":
      datosSeleccionados = n6;
      break;
    case "EA-913005999-N7-2026":
      datosSeleccionados = n7;
      break;
    case "CONVOCATORIA 03-2026":
      datosSeleccionados = convocatoria003;
      break;
    case "EA-913005999-N8-2026":
      datosSeleccionados = n8;
      break;
    case "EA-913005999-N9-2026":
      datosSeleccionados = n9;
      break;
    case "EA-913005999-N10-2026":
      datosSeleccionados = n10;
      break;
    case "CONVOCATORIA 04-2026":
      datosSeleccionados = convocatoria004;
      break;
    case "EA-913005999-N11-2026":
      datosSeleccionados = n11;
      break;
    case "EA-913005999-N12-2026":
      datosSeleccionados = n12;
      break;
    case "EA-913005999-N13-2026":
      datosSeleccionados = n13;
      break;
    case "EA-913005999-N14-2026":
      datosSeleccionados = n14;
      break; 
    case "EA-913005999-N15-2026":
      datosSeleccionados = n15;
      break;
      case "CONVOCATORIA 05-2026":
      datosSeleccionados = convocatoria005;
      break;
      case "EA-913005999-N16-2026":
      datosSeleccionados = n16;
      break; 
      case "EA-913005999-N17-2026":
      datosSeleccionados = n17;
      break;
      case "CONVOCATORIA 06-2026":
      datosSeleccionados = convocatoria006;
      break;
      case "EA-913005999-N18-2026":
      datosSeleccionados = n18;
      break;
      case "EA-913005999-N19-2026":
      datosSeleccionados = n19;
      break;
      case "EA-913005999-N20-2026":
      datosSeleccionados = n20;
      break;
      case "EA-913005999-N21-2026":
      datosSeleccionados = n21;
      break;
      case "CONVOCATORIA 01-2026 OBRA":
      datosSeleccionados = convocatoriaObra01;
      break;
      case "CAASIM-HGO-L.O.P.-01-2026":
      datosSeleccionados = lop1;
      break;
      case "CAASIM-HGO-L.O.P.-02-2026":
      datosSeleccionados = lop2;
      break; 
      case "CAASIM-HGO-L.O.P.-03-2026":
      datosSeleccionados = lop3;
      break;
      case "CONVOCATORIA 07-2026":
      datosSeleccionados = convocatoria007; 
      break;
      case "EA-913005999-N22-2026":
      datosSeleccionados = n22;
      break;
       case "EA-913005999-N23-2026":
       datosSeleccionados = n23;
       break;
      case "EA-913005999-N24-2026":
      datosSeleccionados = n24;
      break;
      case "EA-913005999-N25-2026":
      datosSeleccionados = n25;
      break;
      case "EA-913005999-N26-2026":
      datosSeleccionados = n26;
      break;
      case "EA-913005999-N27-2026":
      datosSeleccionados = n27;
      break;
      case "EA-913005999-N28-2026":
      datosSeleccionados = n28;
      break;
      case "CONVOCATORIA 02-2026 OBRA":
      datosSeleccionados = convocatoriaObra02;
      break;
      case "CAASIM-HGO-L.O.P.-04-2026":
      datosSeleccionados = lop4;
      break;  
      case "CONVOCATORIA 08-2026":
      datosSeleccionados = convocatoria008;
      break;
      case "EA-913005999-N29-2026":
      datosSeleccionados = n29;
      break;
      case "EA-913005999-N30-2026":
      datosSeleccionados = n30;
      break;
      case "EA-913005999-N31-2026":
      datosSeleccionados = n31;
      break;
      case "EA-913005999-N32-2026":
      datosSeleccionados = n32;
      break;
      case "CONVOCATORIA 03-2026 OBRA":
      datosSeleccionados = convocatoriaObra03;
      break;
      case "CAASIM-HGO-L.O.P.-05-2026":
      datosSeleccionados = lop5;
      break;  
      case "CAASIM-HGO-L.O.P.-06-2026":
      datosSeleccionados = lop6;
      break;  
       case "CONVOCATORIA 04-2026 OBRA":
      datosSeleccionados = convocatoriaObra04;
      break;
      case "CAASIM-HGO-L.O.P.-07-2026":
      datosSeleccionados = lop7;
      break;
      case "CAASIM-HGO-L.O.P.-08-2026":
      datosSeleccionados = lop8;
      break;
      case "CAASIM-HGO-L.O.P.-09-2026":
      datosSeleccionados = lop9;
      break;
      case "CONVOCATORIA 09-2026":
      datosSeleccionados = convocatoria009;
      break;
      case "EA-913005999-N33-2026":
      datosSeleccionados = n33;
      break;
      case "EA-913005999-N34-2026":
      datosSeleccionados = n34;
      break;
      case "CONVOCATORIA 10-2026":
      datosSeleccionados = convocatoria010;
      break;
      case "EA-913005999-N35-2026":
      datosSeleccionados = n35;
      break;
      case "EA-913005999-N36-2026":
      datosSeleccionados = n36;
      break;
      case "EA-913005999-N37-2026":
      datosSeleccionados = n37;
      break;
      case "EA-913005999-N38-2026":
      datosSeleccionados = n38;
      break;
      case "EA-913005999-N39-2026":
      datosSeleccionados = n39;
      break;
      case "CONVOCATORIA 05-2026 OBRA":
      datosSeleccionados = convocatoriaObra05;
      break;
      case "CAASIM-HGO-L.O.P.-10-2026":
      datosSeleccionados = lop10;
      break;
      case "CAASIM-HGO-L.O.P.-11-2026":
      datosSeleccionados = lop11;
      break;
    default:
      datosSeleccionados = [];
  }

  return datosSeleccionados;
};
